/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_NotificationsInputs */

const en_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const ar_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات`)
};

const bn_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নোটিফিকেশন`)
};

const de_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const es_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const fr_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const pt_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const zh_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const tr_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler`)
};

const ru_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

const pl_svchip_notifications = /** @type {(inputs: Svchip_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Svchip_NotificationsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_notifications = /** @type {((inputs?: Svchip_NotificationsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_NotificationsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_notifications(inputs)
	if (locale === "bn") return bn_svchip_notifications(inputs)
	if (locale === "de") return de_svchip_notifications(inputs)
	if (locale === "es") return es_svchip_notifications(inputs)
	if (locale === "fr") return fr_svchip_notifications(inputs)
	if (locale === "pt") return pt_svchip_notifications(inputs)
	if (locale === "zh") return zh_svchip_notifications(inputs)
	if (locale === "tr") return tr_svchip_notifications(inputs)
	if (locale === "ru") return ru_svchip_notifications(inputs)
	if (locale === "pl") return pl_svchip_notifications(inputs)
	return en_svchip_notifications(inputs)
});